import React, { PropsWithChildren } from 'react';

import styles from './ButtonsSection.scss';
import { ClassNameProps } from '@/Types';
import cn from 'classnames';

type Props = {
  id?: string;
  position?: 'left' | 'right' | 'center' | 'space-between';
} & ClassNameProps;

export function ButtonsWrapper({ id, children, className, position = 'right' }: PropsWithChildren<Props>) {
  return (
    <div id={id} className={cn(styles.wrapper, styles[position], className)}>
      {children}
    </div>
  );
}
